(function (global) {
  'use strict';

  const STATUS = Object.freeze({ AUTO: 'AUTO', UNSUPPORTED: 'UNSUPPORTED' });
  const PRIMARY_DNS = Object.freeze([130, 150, 180, 200]);
  const WALL_DISTANCES_MM = Object.freeze([50, 100, 150, 200, 250, 300, 360]);
  const MAX_HOLDER_SPACING_MM = 4000;
  const STANDARD_FREE_HEIGHT_MM = 2000;
  const OFFICIAL_MAX_FREE_HEIGHT_MM = 3000;
  const FIXED_HEIGHT_BY_DN_MM = Object.freeze({ 130: 855, 150: 875, 180: 905, 200: 925 });
  const FIRST_HOLDER_REFERENCE_BY_DN_MM = Object.freeze({ 130: 775, 150: 795, 180: 825, 200: 845 });
  const MAX_BUILD_HEIGHT_ABOVE_TEE_MM = Object.freeze({ 130: 34000, 150: 28000, 180: 21000, 200: 17000 });
  const INSTALLED_LENGTH_MM = Object.freeze({ LENGTH_1000: 942, LENGTH_500: 442, DWCOLOR_290_DWETN15: 188 });
  const HEIGHT_RECIPES = Object.freeze([
    { id: 'H1', customerLabel: 'ca. 1,8 m', counts: { LENGTH_1000: 1, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H2', customerLabel: 'ca. 2,3 m', counts: { LENGTH_1000: 1, LENGTH_500: 1, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H3', customerLabel: 'ca. 2,4 m', counts: { LENGTH_1000: 1, LENGTH_500: 1, DWCOLOR_290_DWETN15: 1 } },
    { id: 'H4', customerLabel: 'ca. 2,6 m', counts: { LENGTH_1000: 1, LENGTH_500: 1, DWCOLOR_290_DWETN15: 2 } },
    { id: 'H5', customerLabel: 'ca. 2,8 m', counts: { LENGTH_1000: 2, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H6', customerLabel: 'ca. 3,7 m', counts: { LENGTH_1000: 3, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H7', customerLabel: 'ca. 4,6 m', counts: { LENGTH_1000: 4, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H8', customerLabel: 'ca. 5,6 m', counts: { LENGTH_1000: 5, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H9', customerLabel: 'ca. 6,5 m', counts: { LENGTH_1000: 6, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H10', customerLabel: 'ca. 7,4 m', counts: { LENGTH_1000: 7, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } },
    { id: 'H11', customerLabel: 'ca. 8,4 m', counts: { LENGTH_1000: 8, LENGTH_500: 0, DWCOLOR_290_DWETN15: 0 } }
  ].map(Object.freeze));
  const HEIGHT_RECIPE_BY_ID = Object.freeze(Object.fromEntries(HEIGHT_RECIPES.map((recipe) => [recipe.id, recipe])));
  const INTERNAL_PILOT_RECIPE = Object.freeze({
    id: 'PILOT_4097',
    customerLabel: 'Technischer Pilot 4.097 mm',
    dn: 150,
    counts: Object.freeze({ LENGTH_1000: 3, LENGTH_500: 1, DWCOLOR_290_DWETN15: 0 }),
    technicalMm: 4097,
    cut: Object.freeze({ functionId: 'LENGTH_500', nominalMm: 442, installedMm: 396, cutMm: 46 })
  });
  const WALL_HOLDER_BY_DISTANCE = Object.freeze({
    50: 'DWCOLOR_DWECO21',
    100: 'WALL_HOLDER_ADJUSTABLE_50_150',
    150: 'WALL_HOLDER_ADJUSTABLE_50_150',
    200: 'DWCOLOR_DWECO23',
    250: 'DWCOLOR_DWECO23',
    300: 'DWCOLOR_DWECO24',
    360: 'DWCOLOR_DWECO24'
  });
  const WALL_SUPPORT_BY_DN_AND_DISTANCE = Object.freeze({
    130: Object.freeze({ 50: 'SUPPORT_BRACKET_TYPE_I_350', 100: 'SUPPORT_BRACKET_TYPE_I_350', 150: 'SUPPORT_BRACKET_TYPE_I_350', 200: 'DWCOLOR_DW392', 250: 'DWCOLOR_DW392', 300: 'DWCOLOR_DW392', 360: 'DWCOLOR_DW393' }),
    150: Object.freeze({ 50: 'SUPPORT_BRACKET_TYPE_I_350', 100: 'SUPPORT_BRACKET_TYPE_I_350', 150: 'DWCOLOR_DW392', 200: 'DWCOLOR_DW392', 250: 'DWCOLOR_DW392', 300: 'DWCOLOR_DW393', 360: 'DWCOLOR_DW393' }),
    180: Object.freeze({ 50: 'SUPPORT_BRACKET_TYPE_I_350', 100: 'SUPPORT_BRACKET_TYPE_I_350', 150: 'DWCOLOR_DW392', 200: 'DWCOLOR_DW392', 250: 'DWCOLOR_DW392', 300: 'DWCOLOR_DW393', 360: 'DWCOLOR_DW393' }),
    200: Object.freeze({ 50: 'SUPPORT_BRACKET_TYPE_I_350', 100: 'DWCOLOR_DW392', 150: 'DWCOLOR_DW392', 200: 'DWCOLOR_DW392', 250: 'DWCOLOR_DW393', 300: 'DWCOLOR_DW393', 360: 'DWCOLOR_DW393' })
  });
  const COMPONENT_LABELS = Object.freeze({
    SUPPORT_BRACKET_TYPE_I_350: 'Wandstütze mit Querträger Typ I (350 mm)',
    DWCOLOR_DW392: 'Wandstütze mit Querträger Typ II (500 mm)',
    DWCOLOR_DW393: 'Wandstütze mit Querträger Typ III (750 mm)',
    BASE_PLATE_DRAIN_BOTTOM: 'Grundplatte mit Kondensatablauf unten',
    INSPECTION_ELEMENT: 'Revisionselement',
    T_CONNECTION_90: 'T-Anschluss 90° mit integrierter Wassernase',
    LENGTH_1000: 'Längenelement 1.000 mm',
    LENGTH_500: 'Längenelement 500 mm',
    DWCOLOR_290_DWETN15: 'Längenelement 250 mm',
    DWCOLOR_DWECO21: 'Wandhalter 50 mm',
    WALL_HOLDER_ADJUSTABLE_50_150: 'Wandhalter verstellbar 50–150 mm',
    DWCOLOR_DWECO23: 'Wandhalter verstellbar 50–250 mm',
    DWCOLOR_DWECO24: 'Wandhalter verstellbar 250–360 mm',
    WEATHER_COLLAR: 'Wetterkragen / Wandrosette',
    TERMINAL_CAP: 'Mündungsabschluss'
  });

  function assertAdapter(adapter) {
    if (!adapter || !/^DW-(BLACK|GREY|WHITE)$/.test(String(adapter.systemKey || ''))) throw new Error('INVALID_DW_COLOR_SYSTEM');
    if (!String(adapter.skuPrefix || '').endsWith('-')) throw new Error('INVALID_DW_COLOR_SKU_PREFIX');
  }

  function catalogKey(system, functionId, dn) {
    return `${system}|${functionId}|${dn === null || dn === undefined ? '*' : Number(dn)}`;
  }

  function defaultState() {
    return { dn: 150, heightClassId: 'H7', wallDistanceMm: 100 };
  }

  function normalizeState(input) {
    const state = Object.assign(defaultState(), input || {});
    state.dn = Number(state.dn);
    state.heightClassId = String(state.heightClassId || '').toUpperCase();
    state.wallDistanceMm = Number(state.wallDistanceMm);
    return state;
  }

  function getHeightRecipe(heightClassId, includeInternal) {
    const id = String(heightClassId || '').toUpperCase();
    if (includeInternal && id === INTERNAL_PILOT_RECIPE.id) return INTERNAL_PILOT_RECIPE;
    return HEIGHT_RECIPE_BY_ID[id] || null;
  }

  function calculateTechnicalHeightMm(dn, heightClassId, includeInternal) {
    const diameter = Number(dn);
    const recipe = getHeightRecipe(heightClassId, includeInternal);
    if (!PRIMARY_DNS.includes(diameter) || !recipe) return null;
    if (recipe.id === INTERNAL_PILOT_RECIPE.id) return diameter === recipe.dn ? recipe.technicalMm : null;
    return FIXED_HEIGHT_BY_DN_MM[diameter]
      + (recipe.counts.LENGTH_1000 * INSTALLED_LENGTH_MM.LENGTH_1000)
      + (recipe.counts.LENGTH_500 * INSTALLED_LENGTH_MM.LENGTH_500)
      + (recipe.counts.DWCOLOR_290_DWETN15 * INSTALLED_LENGTH_MM.DWCOLOR_290_DWETN15);
  }

  function selectWallSupport(dn, wallDistanceMm) {
    return WALL_SUPPORT_BY_DN_AND_DISTANCE[Number(dn)]?.[Number(wallDistanceMm)] || null;
  }

  function selectWallHolder(wallDistanceMm) {
    return WALL_HOLDER_BY_DISTANCE[Number(wallDistanceMm)] || null;
  }

  function calculateHolderCount(technicalHeightMm, dn) {
    const height = Number(technicalHeightMm);
    const first = FIRST_HOLDER_REFERENCE_BY_DN_MM[Number(dn)];
    if (!Number.isFinite(height) || !Number.isFinite(first) || height <= first) return 0;
    return 1 + Math.max(0, Math.ceil((height - first - STANDARD_FREE_HEIGHT_MM) / MAX_HOLDER_SPACING_MM));
  }

  function calculateHolderPositionsMm(technicalHeightMm, dn, holderCount) {
    const height = Number(technicalHeightMm);
    const first = FIRST_HOLDER_REFERENCE_BY_DN_MM[Number(dn)];
    const quantity = Number(holderCount);
    if (!Number.isInteger(quantity) || quantity < 1 || !Number.isFinite(height) || !Number.isFinite(first)) return [];
    if (quantity === 1) return [first];
    const last = height - STANDARD_FREE_HEIGHT_MM;
    const upper = [];
    for (let remainingIntervals = quantity - 2; remainingIntervals >= 0; remainingIntervals -= 1) {
      upper.push(last - (remainingIntervals * MAX_HOLDER_SPACING_MM));
    }
    return [first].concat(upper);
  }

  function buildBlueprint(state, recipe, holderQuantity) {
    const support = selectWallSupport(state.dn, state.wallDistanceMm);
    const holder = selectWallHolder(state.wallDistanceMm);
    return [
      { role: 'WALL_SUPPORT', functionId: support, dn: null, quantity: 1, rule: 'SUPPORT_MATRIX' },
      { role: 'BASE_PLATE', functionId: 'BASE_PLATE_DRAIN_BOTTOM', dn: state.dn, quantity: 1, rule: 'STANDARD_START' },
      { role: 'INSPECTION', functionId: 'INSPECTION_ELEMENT', dn: state.dn, quantity: 1, rule: 'STANDARD_START' },
      { role: 'TEE_90', functionId: 'T_CONNECTION_90', dn: state.dn, quantity: 1, rule: 'STANDARD_START_INTEGRATED_WATER_NOSE' },
      { role: 'LENGTH_1000', functionId: 'LENGTH_1000', dn: state.dn, quantity: recipe.counts.LENGTH_1000, rule: recipe.id },
      { role: 'LENGTH_500', functionId: 'LENGTH_500', dn: state.dn, quantity: recipe.counts.LENGTH_500, rule: recipe.id },
      { role: 'LENGTH_250', functionId: 'DWCOLOR_290_DWETN15', dn: state.dn, quantity: recipe.counts.DWCOLOR_290_DWETN15, rule: recipe.id },
      { role: 'WALL_HOLDER', functionId: holder, dn: state.dn, quantity: holderQuantity, rule: 'DISTANCE_AND_HEIGHT' },
      { role: 'WEATHER_COLLAR', functionId: 'WEATHER_COLLAR', dn: state.dn, quantity: 1, rule: 'STANDARD_START' },
      { role: 'TERMINAL', functionId: 'TERMINAL_CAP', dn: state.dn, quantity: 1, rule: 'STANDARD_TERMINAL' }
    ].filter((line) => line.quantity > 0);
  }

  function resolveCatalogRow(catalog, adapter, line, issues) {
    const key = catalogKey(adapter.systemKey, line.functionId, line.dn);
    const row = catalog?.[key] || null;
    if (!row) {
      issues.push({ code: 'MAPPING_MISSING', key, functionId: line.functionId, dn: line.dn });
      return null;
    }
    if (row.system !== adapter.systemKey || row.functionId !== line.functionId || (line.dn === null ? row.dn !== null : Number(row.dn) !== Number(line.dn))) {
      issues.push({ code: 'MAPPING_KEY_MISMATCH', key });
    }
    const sku = String(row.sku || '');
    const colorPrefix = ['16-', '28-', '47-'].find((prefix) => sku.startsWith(prefix)) || null;
    if (!sku.startsWith(adapter.skuPrefix)) issues.push({ code: 'UNEXPECTED_COLOR_SKU', key, sku: row.sku });
    if (colorPrefix && colorPrefix !== adapter.skuPrefix) issues.push({ code: 'COLOR_SKU_LEAK', key, sku: row.sku, expectedPrefix: adapter.skuPrefix });
    if (!/^\d+$/.test(String(row.variantId || ''))) issues.push({ code: 'VARIANT_ID_INVALID', key, variantId: row.variantId });
    if (!/^\d+$/.test(String(row.productId || ''))) issues.push({ code: 'PRODUCT_ID_INVALID', key, productId: row.productId });
    if (row.active !== true) issues.push({ code: 'PRODUCT_NOT_ACTIVE', key, sku: row.sku });
    if (row.buyable !== true) issues.push({ code: 'VARIANT_NOT_BUYABLE', key, sku: row.sku });
    if (!Number.isInteger(row.priceCents) || row.priceCents <= 0) issues.push({ code: 'PRICE_MISSING', key, sku: row.sku });
    return row;
  }

  function resolve(adapter, input, catalog, includeInternal) {
    assertAdapter(adapter);
    const state = normalizeState(input);
    const errors = [];
    if (!PRIMARY_DNS.includes(state.dn)) errors.push({ code: 'DN_UNSUPPORTED', value: state.dn });
    if (!WALL_DISTANCES_MM.includes(state.wallDistanceMm)) errors.push({ code: 'WALL_DISTANCE_UNSUPPORTED', value: state.wallDistanceMm });
    const recipe = getHeightRecipe(state.heightClassId, includeInternal);
    if (!recipe) errors.push({ code: 'HEIGHT_RECIPE_UNSUPPORTED', value: state.heightClassId });
    if (recipe?.id === INTERNAL_PILOT_RECIPE.id && state.dn !== INTERNAL_PILOT_RECIPE.dn) errors.push({ code: 'PILOT_RECIPE_DN_MISMATCH', value: state.dn });
    if (errors.length) return { state, status: STATUS.UNSUPPORTED, errors, bom: [], cartEligible: false };

    const technicalHeightMm = calculateTechnicalHeightMm(state.dn, recipe.id, includeInternal);
    if (!Number.isInteger(technicalHeightMm) || technicalHeightMm > MAX_BUILD_HEIGHT_ABOVE_TEE_MM[state.dn]) {
      errors.push({ code: 'BUILD_HEIGHT_GATE_FAILED', technicalHeightMm });
      return { state, status: STATUS.UNSUPPORTED, errors, bom: [], cartEligible: false };
    }
    const holderQuantity = calculateHolderCount(technicalHeightMm, state.dn);
    const holderPositionsMm = calculateHolderPositionsMm(technicalHeightMm, state.dn, holderQuantity);
    const maxSpacingMm = holderPositionsMm.length < 2 ? 0 : Math.max(...holderPositionsMm.slice(1).map((value, index) => value - holderPositionsMm[index]));
    const freeHeightMm = technicalHeightMm - holderPositionsMm.at(-1);
    if (!holderQuantity || maxSpacingMm > MAX_HOLDER_SPACING_MM || freeHeightMm > OFFICIAL_MAX_FREE_HEIGHT_MM) {
      errors.push({ code: 'HOLDER_LOGIC_GATE_FAILED', holderQuantity, holderPositionsMm, maxSpacingMm, freeHeightMm });
    }

    const blueprint = buildBlueprint(state, recipe, holderQuantity);
    const bom = blueprint.map((line) => {
      const row = resolveCatalogRow(catalog, adapter, line, errors);
      const unitPriceCents = row && Number.isInteger(row.priceCents) ? row.priceCents : null;
      return {
        ...line,
        system: adapter.systemKey,
        label: COMPONENT_LABELS[line.functionId] || row?.productTitle || line.functionId,
        sku: row?.sku || null,
        productId: row?.productId || null,
        variantId: row?.variantId || null,
        unitPriceCents,
        linePriceCents: unitPriceCents === null ? null : unitPriceCents * line.quantity
      };
    });
    const totalPriceCents = errors.length === 0 ? bom.reduce((sum, line) => sum + line.linePriceCents, 0) : null;
    return {
      state,
      system: adapter.systemKey,
      systemLabel: adapter.systemLabel,
      status: errors.length === 0 ? STATUS.AUTO : STATUS.UNSUPPORTED,
      errors,
      height: {
        classId: recipe.id,
        customerLabel: recipe.customerLabel,
        technicalMm: technicalHeightMm,
        counts: { ...recipe.counts },
        cut: recipe.cut ? { ...recipe.cut } : null
      },
      holder: {
        functionId: selectWallHolder(state.wallDistanceMm),
        quantity: holderQuantity,
        firstReferenceMm: FIRST_HOLDER_REFERENCE_BY_DN_MM[state.dn],
        positionsMm: holderPositionsMm,
        maxSpacingMm,
        freeHeightMm
      },
      support: { functionId: selectWallSupport(state.dn, state.wallDistanceMm) },
      bom,
      totalPositions: bom.length,
      totalComponents: bom.reduce((sum, line) => sum + line.quantity, 0),
      totalPriceCents,
      cartEligible: errors.length === 0 && Number.isInteger(totalPriceCents) && totalPriceCents > 0,
      fireplaceTransitionIncluded: false,
      waterNoseIntegratedInTee: true
    };
  }

  function buildCartPayload(result, configurationId) {
    if (!result?.cartEligible) throw new Error('CONFIGURATION_NOT_CART_ELIGIBLE');
    const id = configurationId || `dw-color-${Date.now().toString(36)}`;
    return {
      items: result.bom.map((line) => ({
        id: String(line.variantId),
        quantity: line.quantity,
        properties: {
          '_Konfiguration': id,
          'System': result.systemLabel,
          'Nennweite': `DN ${result.state.dn}`,
          'Höhenklasse': result.height.customerLabel,
          'Technische Höhe': `${result.height.technicalMm} mm`,
          'Wandabstand': `${result.state.wallDistanceMm} mm`,
          '_Funktion': line.functionId,
          '_Jeremias SKU': line.sku
        }
      }))
    };
  }

  function createSystemAdapter(adapter) {
    assertAdapter(adapter);
    const frozenAdapter = Object.freeze({ ...adapter });
    return Object.freeze({
      STATUS,
      PRIMARY_DNS,
      WALL_DISTANCES_MM,
      HEIGHT_RECIPES,
      INTERNAL_PILOT_RECIPE,
      FIXED_HEIGHT_BY_DN_MM,
      INSTALLED_LENGTH_MM,
      MAX_HOLDER_SPACING_MM,
      STANDARD_FREE_HEIGHT_MM,
      OFFICIAL_MAX_FREE_HEIGHT_MM,
      WALL_HOLDER_BY_DISTANCE,
      WALL_SUPPORT_BY_DN_AND_DISTANCE,
      COMPONENT_LABELS,
      adapter: frozenAdapter,
      catalogKey,
      defaultState,
      normalizeState,
      getHeightRecipe,
      calculateTechnicalHeightMm,
      selectWallSupport,
      selectWallHolder,
      calculateHolderCount,
      calculateHolderPositionsMm,
      buildBlueprint,
      resolveConfiguration(input, catalog) { return resolve(frozenAdapter, input, catalog, false); },
      resolveInternalFixture(input, catalog) { return resolve(frozenAdapter, input, catalog, true); },
      buildCartPayload
    });
  }

  const api = Object.freeze({ createSystemAdapter, catalogKey });
  global.JeremiasDwColorEngine = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
